import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import VoyahFreeSpec from '../../components/VoyahFreeSpec/VoyahFreeSpec'
import Gallery from '../../components/Gallery/Gallery'

const VoyahFreeSpecifications = () => {
  return (
    <div className='vfcna'>
      <Navbar customColor="freeSpec"/>
      <VoyahFreeSpec/>
      <Gallery/>
      <Footer/>
    </div>
  )
}

export default VoyahFreeSpecifications
